export default __webpack_public_path__ + "static/media/migration.0ab306b7.png";